// Chat.js

import React, { useState } from 'react';
import axios from 'axios';

import logoAlexa from '../img/brands/alexa.svg'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postChatQuestionURL = endpointHelias+'/3rdParty/V0/OpenAI/postChatQuestion'

var generalCommonJS = require("../js/generalCommon.js");

const Chat = () => {

    const [input, setInput] = useState('');

    const enviarMensaje = async () => {

        try{

            if(document.getElementById("cajaTextoChat").value !== ""){

              document.getElementById("cajaTextoChat").placeholder = ""              
              document.getElementById("cajaTextoChat").className = ""

              document.getElementById("botonEnviarChat").className = document.getElementById("botonEnviarChat").className.replaceAll(" loading","") + " loading"

              var p = document.createElement('p'); 
              p.style = "margin-top:10px;margin-bottom:10px;padding-top:10px;padding-bottom:10px"       
              p.className = "bubble"
              p.innerHTML = "<strong>"+generalCommonJS.obtenerNombreUsuario()+":</strong> " + document.getElementById("cajaTextoChat").value; 
              document.getElementById("divConversacion").appendChild(p);

              var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
              var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

              const headers = {
                  'Content-Type': 'application/json',
                  'Authorization': lastAuthUserIdToken,
              };

              const requestBody = {
                  "accountID": localStorage.getItem("accountID"),
                  "installationID": localStorage.getItem("installationId"),
                  "message": document.getElementById("cajaTextoChat").value,
                  "userName": generalCommonJS.obtenerNombreUsuario()
              }

              setInput("")

              const { data } = await axios.post(postChatQuestionURL, requestBody, { headers });

              p = document.createElement('p');        
              p.style = "margin-top:10px;margin-bottom:10px;padding-top:10px;padding-bottom:10px"       
              p.className = "bubble"
              p.innerHTML = "<strong>Helias:</strong> " + data.body
              document.getElementById("divConversacion").appendChild(p);

              document.getElementById("divDetalleLateral").scrollTop = document.getElementById("divDetalleLateral").scrollHeight;
              
              document.getElementById("botonEnviarChat").className = document.getElementById("botonEnviarChat").className.replaceAll(" loading","") 
            }
            else{

              document.getElementById("cajaTextoChat").placeholder = "Escribe aquí tu pregunta"              
              document.getElementById("cajaTextoChat").className = "error"

            }

            
        }
        catch(error){

            p = document.createElement('p');        
            p.style = "margin-top:10px;margin-bottom:10px;padding-top:10px;padding-bottom:10px"       
            p.className = "bubble"
            p.innerHTML = "<strong>Helias:</strong> Estoy teniendo problemas, prueba a preguntarme pasados unos minutos."
            document.getElementById("divConversacion").appendChild(p);

            setInput("")

            document.getElementById("divDetalleLateral").scrollTop = document.getElementById("divDetalleLateral").scrollHeight;            
            document.getElementById("botonEnviarChat").className = document.getElementById("botonEnviarChat").className.replaceAll(" loading","") 

        }
            
    }

  const handleKeyDown = (event) => {

    document.getElementById("cajaTextoChat").className = ""
    document.getElementById("cajaTextoChat").placeholder = ""

    if (event.key === 'Enter') {   
      event.preventDefault()   
      enviarMensaje()
    }
  }  

  function nuevaConversacion(){
    document.getElementById("divConversacion").innerHTML = ""
    setInput("")
  }

  return (
    <div>
      
      <div id="divConversacion" style={{ marginTop: "-15px", marginBottom: "15px"}}>         
      </div> 

      <div className='horizontal gap-02' >
        <textarea
          id="cajaTextoChat"
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button id="botonEnviarChat" className="button primary" onClick={enviarMensaje}>Enviar</button>

      </div>
      <button id="botonNuevaConversación" className="link" onClick={nuevaConversacion}><span className="material-icon">maps_ugc</span>Nueva conversación</button>

      <div className="message info left" style={{marginTop: "20px"}}>
        <div className="horizontal">
          <figure className="avatar size-xl "><img src={logoAlexa} width="50" height="50"/></figure>
          <p className="size-s">Si prefieres hablar, <a href="https://www.amazon.es/dp/B0F5WJ21D5" className="link inline-link" target="_blank" rel="noopener noreferrer" title="Alexa skill">activa aquí mi skill</a> de Alexa y configúrala en <a href="./InstallationConfiguration/Messaging" className="link inline-link" rel="noopener noreferrer" title="Alexa skill">Configuración → Mensajería y Alexa</a>.</p>
        </div>
      </div>
      
    </div>
  );
};

export default Chat;